<template>
    <div class="content">
        <div class="container-fluid">
            <PageTitle :title="$t('WithdrawalPointList.withdrawalPointList')">
                <template v-slot:left>
                    <i class="fas fa-store fa-3x text-distribution"/>
                </template>
            </PageTitle>
            <transition mode="out-in" name="fade">
                <APILoading v-if="withdrawalPoints === undefined" key="loading" :color="$data.$colors.distribution" :text="$t('WithdrawalPointList.loadingWithdrawalPoints')"/>
                <div class="row" v-else>
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <v-client-table :data="withdrawalPoints" :columns="table.columns" :options="table.options">
                                    <button @click="showWithdrawalPointModal()" class="btn btn-primary pull-right" slot="afterLimit">
                                        <i class="fa fa-plus-circle mr-1"/>
                                        <span v-html="$t('WithdrawalPointList.addWithdrawalPoint')"/>
                                    </button>
                                    <span class="font-bold" slot-scope="props" slot="name" v-html="props.row.name"/>
                                    <span slot-scope="props" slot="address" v-html="props.row.addressLabel"/>
                                    <span slot-scope="props" slot="priceWT" v-html="props.row.getChargedByLabel(currencies)"/>
                                    <div slot-scope="props" slot="actions">
                                        <button v-tooltip="$t('WithdrawalPointList.edit')" @click="showWithdrawalPointModal(props.row)"
                                                class="btn btn-warning btn-xs ml-1">
                                            <i class="fa fa-edit"/>
                                        </button>
                                    </div>
                                </v-client-table>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <WithdrawalPointFormModal ref="WithdrawalPointFormModal" @addWithdrawalPoint="addWithdrawalPoint" @editWithdrawalPoint="editWithdrawalPoint"/>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageTitle from "../../../shared/misc/PageTitle";
import APILoading from "../../../shared/API/APILoading";
import { permissiveFilter } from "../../../../helpers/VueTable";
import WithdrawalPoint from "../../../../classes/Distribution/WithdrawalPoint";
import WithdrawalPointFormModal from "../../../shared/Distribution/WithdrawalPoint/WithdrawalPointFormModal";

export default {
    name: "WithdrawalPointList",
    components: { WithdrawalPointFormModal, APILoading, PageTitle },
    // eslint-disable-next-line max-lines-per-function
    data() {
        return {
            withdrawalPoints: undefined,
            table: {
                columns: ["name", "address", "priceWT", "actions"],
                options: {
                    sortable: ["name"],
                    perPage: 10,
                    headings: {
                        name: this.$t("WithdrawalPointList.name"),
                        address: this.$t("WithdrawalPointList.address"),
                        priceWT: this.$t("WithdrawalPointList.priceWT"),
                    },
                    orderBy: {
                        column: "name",
                    },
                    filterAlgorithm: {
                        name: (row, query) => permissiveFilter(row.name, query),
                        address: (row, query) => permissiveFilter(row.addressLabel, query),
                        priceWT: (row, query) => permissiveFilter(row.getChargedByLabel(this.currencies), query),
                    },
                    cellClasses: {
                        actions: [{
                            class: "text-center",
                            condition: () => true,
                        }],
                    },
                },
            },
        };
    },
    computed: {
        ...mapGetters("currencies", {
            currencies: "currencies",
        }),
    },
    async created() {
        if (!await this.checkUserAuthentication()) {
            return;
        }
        await this.getWithdrawalPoints();
    },
    methods: {
        ...mapActions("user", {
            checkUserAuthentication: "checkUserAuthentication",
        }),
        async getWithdrawalPoints() {
            try {
                const { data } = await this.$hermesAPI.getWithdrawalPoints();
                this.withdrawalPoints = data.map(withdrawalPoint => new WithdrawalPoint(withdrawalPoint));
            } catch (e) {
                this.$displayError(e);
            }
        },
        showWithdrawalPointModal(withdrawalPoint = null) {
            this.$refs.WithdrawalPointFormModal.show(withdrawalPoint);
        },
        addWithdrawalPoint(withdrawalPoint) {
            this.withdrawalPoints.push(new WithdrawalPoint(withdrawalPoint));
        },
        editWithdrawalPoint(updatedWithdrawalPoint) {
            const idx = this.withdrawalPoints.findIndex(withdrawalPoint => withdrawalPoint._id === updatedWithdrawalPoint._id);
            if (idx !== -1) {
                this.withdrawalPoints.splice(idx, 1, new WithdrawalPoint(updatedWithdrawalPoint));
            }
        },
    },
};
</script>

<style scoped>

</style>